import { useState, useEffect } from "react";
import { ProSidebar, Menu, MenuItem } from "react-pro-sidebar";
import "react-pro-sidebar/dist/css/styles.css";
import { Box, IconButton, Typography, useTheme } from "@mui/material";
import { Link } from "react-router-dom";
import { tokens } from "../../contexts/theme";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import WaterRoundedIcon from "@mui/icons-material/WaterRounded";
import WaterDropRoundedIcon from "@mui/icons-material/WaterDropRounded";
import AirRoundedIcon from "@mui/icons-material/AirRounded";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import WbSunnyRoundedIcon from "@mui/icons-material/WbSunnyRounded";
import DeviceThermostatRoundedIcon from "@mui/icons-material/DeviceThermostatRounded";
import VibrationRoundedIcon from "@mui/icons-material/VibrationRounded";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import SensorDoorIcon from '@mui/icons-material/SensorDoor';

const Item = ({ title, to, icon, selected, setSelected, isolated, compList }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <MenuItem
      active={selected === to}
      style={{ color: colors.grey[100] }}
      onClick={() => {
        setSelected(to)
        isolated(compList)
      }}
      icon={icon}
    >
      <Typography>{title}</Typography>
      <Link to={to} />
    </MenuItem>
  );
};

const Sidebar = ({isolation}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [selected, setSelected] = useState("");

  useEffect(() => {
    const currentRoute = window.location.pathname;
    setSelected(currentRoute);
  }, []);

  return (
    <Box
      sx={{
        "& .pro-sidebar-inner": {
          background: `${colors.primary[400]} !important`,
        },
        "& .pro-icon-wrapper": {
          backgroundColor: "transparent !important",
        },
        "& .pro-inner-item": {
          padding: "5px 35px 5px 20px !important",
        },
        "& .pro-inner-item:hover": {
          color: "#868dfb !important",
        },
        "& .pro-menu-item.active": {
          color: "#6870fa !important",
        },
      }}
    >
      <ProSidebar collapsed={isCollapsed}>
        <Menu iconShape="square">
          {/* LOGO AND MENU ICON */}
          <MenuItem
            onClick={() => setIsCollapsed(!isCollapsed)}
            icon={isCollapsed ? <MenuOutlinedIcon /> : undefined}
          >
            {!isCollapsed && (
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                ml="15px"
              >
                <Box></Box>
                {/* <Typography variant="h5" color={colors.grey[700]} mt="5px">
                  ADMIN PAGE
                </Typography> */}
                <IconButton onClick={() => setIsCollapsed(!isCollapsed)}>
                  <MenuOutlinedIcon />
                </IconButton>
              </Box>
            )}
          </MenuItem>

          {/* USER */}
          {!isCollapsed && (
            <Box mb="25px">
              <Box display="flex" justifyContent="center" alignItems="center">
                <img
                  alt="profile-logo"
                  width="100px"
                  height="100px"
                  src={`../../assets/logo.png`}
                />
              </Box>

              <Box textAlign="center">
                <Typography
                  variant="h3"
                  color={colors.grey[100]}
                  fontWeight="bold"
                  sx={{ m: "10px 0 0 0" }}
                >
                  태양광 방음터널
                </Typography>
                <Typography variant="h6" color={colors.grey[100]}>
                  (위치 : 전주시, 대한민국)
                </Typography>
                <Typography variant="h6"
                  color={colors.greenAccent[400]}
                  sx={{ m: "10px 0 0 0" }}
                >
                  BIM-디지털 트윈 모니터링 시스템
                </Typography>
              </Box>
            </Box>
          )}

          {/* MENU ITEMS */}
          <Box paddingLeft={isCollapsed ? undefined : "10%"}>
            <Item
              title="Dashboard"
              to="/"
              icon={<HomeOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
              isolated={isolation}
              compList={[]}
            />

            <Typography
              variant="h6"
              color={colors.grey[300]}
              sx={{ m: "15px 0 5px 20px" }}
            >
              Charts
            </Typography>
            <Item
              title="공기질 데이터"
              to="/airquality"
              icon={<AirRoundedIcon />}
              selected={selected}
              setSelected={setSelected}
              isolated={isolation}
              compList={[ 57769, 57759 ]} // rvt 파일에서 위치 알려주는 리스트
              // client\src\forge\extensions\LoggerExtension.js 파일에서 console로 나옴 "이벤트~~~"
            />
            <Item
              title="태양광 데이터"
              to="/solarenergy"
              icon={<WbSunnyRoundedIcon />}
              selected={selected}
              setSelected={setSelected}
              isolated={isolation}
              compList={[ 57780, 57779 ]}
            />
            <Item
              title="물감지 데이터"
              to="/waterdetection"
              icon={<WaterDropRoundedIcon />}
              selected={selected}
              setSelected={setSelected}
              isolated={isolation}
              compList={[ 57768, 57755 ]}
            />
            <Item
              title="기울기  데이터"
              to="/tiltdetection"
              icon={<WaterRoundedIcon />}
              selected={selected}
              setSelected={setSelected}
              isolated={isolation}
              compList={[ 57767, 57771 ]}
            />
            <Item
              title="온도  데이터"
              to="/temperature"
              icon={<DeviceThermostatRoundedIcon />}
              selected={selected}
              setSelected={setSelected}
              isolated={isolation}
              compList={[ 57763, 57770 ]}
            />
            <Item
              title="진동  데이터"
              to="/vibration"
              icon={<VibrationRoundedIcon />}
              selected={selected}
              setSelected={setSelected}
              isolated={isolation}
              compList={[ 57781, 57775 ]}
            />
            <Item
              title="창문  상태"
              to="/window"
              icon={<SensorDoorIcon />}
              selected={selected}
              setSelected={setSelected}
              isolated={isolation}
              compList={[  ]}
            />

            {/* 기타 페이지 */}
            <Typography
              variant="h6"
              color={colors.grey[300]}
              sx={{ m: "15px 0 5px 20px" }}
            >
              Pages
            </Typography>
            <Item
              title="기타 문서"
              to="/others"
              icon={<HelpOutlineOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
              isolated={isolation}
              compList={[]}
            />
          </Box>
        </Menu>
      </ProSidebar>
    </Box>
  );
};

export default Sidebar;
